/**
 * Auth Layout Component
 *
 * Pre-login layout matching post-login style:
 * - Mobile: Bottom nav bar with centered "Gym" button, disabled until sign-in
 * - Desktop: Sidebar visible but non-functional until sign-in
 * - Same navigation structure as post-login
 */

import './AuthLayout.css';

interface NavItem {
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  { label: 'Schedule', icon: '📅' },
  { label: 'Notes', icon: '📝' },
  { label: 'Gym', icon: '💪' },
  { label: 'Stats', icon: '📊' },
  { label: 'Settings', icon: '⚙️' },
];

const sidebarNavItems: NavItem[] = [
  { label: 'Gym Tracker', icon: '💪' },
  { label: 'Schedule', icon: '📅' },
  { label: 'Notes', icon: '📝' },
  { label: 'Analytics', icon: '📊' },
];

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps): JSX.Element {
  return (
    <div className="auth-layout">
      {/* Desktop: Disabled Sidebar */}
      <aside className="auth-layout__sidebar">
        <div className="auth-layout__sidebar-header">
          <div className="auth-layout__logo-container">
            <div className="auth-layout__logo-icon">
              <span className="auth-layout__logo-placeholder">M</span>
            </div>
            <h1 className="auth-layout__logo">My OS</h1>
          </div>
        </div>

        <div className="auth-layout__welcome">
          <span className="auth-layout__welcome-text">Welcome</span>
        </div>

        <nav className="auth-layout__sidebar-nav">
          {sidebarNavItems.map((item) => (
            <div
              key={item.label}
              className="auth-layout__sidebar-item auth-layout__sidebar-item--disabled"
            >
              <span className="auth-layout__sidebar-icon">{item.icon}</span>
              <span className="auth-layout__sidebar-label">{item.label}</span>
            </div>
          ))}
        </nav>

        <div className="auth-layout__sidebar-footer">
          <div className="auth-layout__sidebar-message">
            Sign in to access all features
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="auth-layout__content">
        {children}
      </main>

      {/* Mobile: Fidelity-style Bottom Nav (disabled) */}
      <nav className="auth-layout__bottom-nav">
        {navItems.map((item, index) => {
          const isCenterItem = index === 2; // Gym is centered
          return (
            <div
              key={item.label}
              className={`auth-layout__nav-item ${
                isCenterItem ? 'auth-layout__nav-item--center' : ''
              } auth-layout__nav-item--disabled`}
            >
              {isCenterItem ? (
                <div className="auth-layout__nav-center-button">
                  <span className="auth-layout__nav-icon">{item.icon}</span>
                </div>
              ) : (
                <span className="auth-layout__nav-icon">{item.icon}</span>
              )}
              <span className="auth-layout__nav-label">{item.label}</span>
            </div>
          );
        })}
      </nav>
    </div>
  );
}
